// src/pages/help/topics/autres.js
// Guide « Autres ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Autres",
  tagline: "VPS, vision de la plateforme, idées et abonnement",
  readMin: 5,
  intro:
    "FullMetrix a été conçu pour proposer des outils professionnels aux traders. Dans sa version actuelle, la majorité des fonctionnalités sont principalement adaptées aux utilisateurs de MetaTrader 5. Cette page regroupe les sujets transverses : VPS, vision de la plateforme, propositions d'amélioration et fonctionnement de l'abonnement.",
  brief: [
    "Comprendre pourquoi un VPS est recommandé et comment l'utiliser",
    "Connaître la direction que prend la plateforme",
    "Savoir proposer une idée et pourquoi FullMetrix fonctionne par abonnement",
  ],
  steps: [
    {
      title: "Choisir un fournisseur de VPS",
      text: "Un VPS est un serveur distant qui reste actif en permanence, même ordinateur éteint.",
    },
    {
      title: "Installer MetaTrader 5 sur le VPS",
      text: "Connecte-toi au serveur depuis ton ordinateur, installe MT5 puis connecte ton compte de trading.",
    },
    {
      title: "Installer les Agents FullMetrix",
      text: "Installe les Agents nécessaires, puis configure le trading algorithmique, les WebRequest et les tokens.",
    },
    {
      title: "Laisser le terminal ouvert sur le serveur",
      text: "Le VPS fait alors fonctionner MetaTrader 5 et les Agents sans dépendre de l'ordinateur personnel.",
    },
  ],
  tips: [
    "Le VPS est particulièrement recommandé pour profiter pleinement des fonctionnalités automatiques (Copy Trading, synchronisation continue, multi-comptes).",
    "FullMetrix ne garantit ni rentabilité, ni atteinte d'objectif, ni absence de pertes : le trader reste responsable de ses décisions.",
    "Les propositions d'amélioration sont les bienvenues via le support.",
  ],
  faq: [
    {
      q: "À qui s'adresse principalement FullMetrix ?",
      a:
        "FullMetrix a été conçu pour proposer des outils professionnels aux traders.\n\n" +
        "Dans sa version actuelle, la majorité des fonctionnalités sont principalement adaptées aux utilisateurs de MetaTrader 5.\n\n" +
        "Cela concerne notamment :\n" +
        "• l'Agent IA\n" +
        "• le Journal automatique\n" +
        "• l'Exécution des ordres\n" +
        "• le Copy Trading\n" +
        "• les Challenges\n" +
        "• FMReplay et le Backtest\n\n" +
        "D'autres plateformes pourront progressivement être prises en charge avec l'évolution de FullMetrix.",
    },
    {
      q: "Pourquoi utiliser un VPS avec FullMetrix ?",
      a:
        "Un VPS est un serveur informatique distant qui reste actif en permanence.\n\n" +
        "Il permet de faire fonctionner MetaTrader 5 et les Agents FullMetrix même lorsque :\n" +
        "• l'ordinateur personnel est éteint\n" +
        "• l'utilisateur est déconnecté\n" +
        "• l'utilisateur se déplace\n" +
        "• l'utilisateur ne souhaite pas laisser son ordinateur allumé en continu\n\n" +
        "L'utilisation d'un VPS est particulièrement recommandée pour profiter pleinement des fonctionnalités automatiques de FullMetrix.",
    },
    {
      q: "Comment utiliser FullMetrix avec un VPS ?",
      a:
        "L'utilisateur doit :\n\n" +
        "1. choisir un fournisseur de VPS en ligne\n" +
        "2. se connecter au serveur depuis son ordinateur\n" +
        "3. installer MetaTrader 5 sur le VPS\n" +
        "4. connecter son compte de trading\n" +
        "5. installer les Agents FullMetrix nécessaires\n" +
        "6. configurer le trading algorithmique, les WebRequest et les tokens\n" +
        "7. laisser MetaTrader 5 ouvert sur le serveur\n\n" +
        "Une fois la configuration terminée, le VPS continue de faire fonctionner MetaTrader 5 et les Agents sans dépendre de l'ordinateur personnel.",
    },
    {
      q: "Peut-on tout gérer depuis FullMetrix une fois le VPS configuré ?",
      a:
        "L'objectif de FullMetrix est de permettre au trader de gérer une grande partie de son activité directement depuis la plateforme.\n\n" +
        "Lorsque l'Agent est correctement connecté sur un VPS, l'utilisateur peut notamment :\n" +
        "• suivre les données de son compte\n" +
        "• consulter son Journal automatique\n" +
        "• analyser ses performances\n" +
        "• envoyer des ordres\n" +
        "• gérer certaines positions\n" +
        "• utiliser le Copy Trading\n" +
        "• suivre ses Challenges\n\n" +
        "L'utilisateur n'a donc plus besoin d'ouvrir constamment MetaTrader 5 sur son ordinateur personnel.\n\n" +
        "Le terminal doit toutefois rester actif sur le VPS pour maintenir la connexion avec FullMetrix.",
    },
    {
      q: "Quelle est la vision de FullMetrix ?",
      a:
        "FullMetrix ne se limite pas à un seul outil.\n\n" +
        "Notre objectif est de construire progressivement un véritable environnement de gestion et d'assistance pour les traders.\n\n" +
        "La plateforme vise à centraliser :\n" +
        "• les outils de trading\n" +
        "• l'analyse des performances\n" +
        "• l'automatisation\n" +
        "• la gestion des comptes\n" +
        "• le backtest\n" +
        "• la structuration des stratégies\n" +
        "• l'accompagnement par l'intelligence artificielle\n\n" +
        "De nouvelles fonctionnalités seront ajoutées progressivement afin d'étendre les possibilités de la plateforme au-delà de MetaTrader 5.",
    },
    {
      q: "Peut-on proposer une idée ou une amélioration ?",
      a:
        "Oui.\n\n" +
        "FullMetrix évolue également grâce aux retours de sa communauté.\n\n" +
        "Les utilisateurs peuvent contacter le support pour proposer :\n" +
        "• une nouvelle fonctionnalité\n" +
        "• une amélioration d'un outil existant\n" +
        "• une correction\n" +
        "• une idée d'automatisation\n" +
        "• un besoin particulier rencontré dans leur activité de trading\n\n" +
        "Il est recommandé de présenter brièvement :\n" +
        "• le problème rencontré\n" +
        "• la solution proposée\n" +
        "• l'utilité pour les traders\n" +
        "• un exemple concret, si possible\n\n" +
        "Chaque proposition peut nous aider à améliorer la plateforme.",
    },
    {
      q: "Pourquoi FullMetrix fonctionne-t-il avec un abonnement ?",
      a:
        "Les outils proposés nécessitent des frais importants liés notamment :\n" +
        "• au développement\n" +
        "• aux serveurs\n" +
        "• à la maintenance\n" +
        "• à la sécurité\n" +
        "• à l'intelligence artificielle\n" +
        "• aux mises à jour\n" +
        "• au support technique\n\n" +
        "La gestion de ce type d'infrastructure peut représenter plusieurs milliers de dollars.\n\n" +
        "FullMetrix propose néanmoins un abonnement accessible afin de permettre aux traders de profiter durablement de ces outils sans devoir supporter individuellement ces coûts.",
    },
    {
      q: "Quels types d'abonnements sont disponibles ?",
      a:
        "FullMetrix propose des formules d'abonnement permettant d'accéder aux fonctionnalités de la plateforme.\n\n" +
        "Selon les offres disponibles, l'utilisateur peut choisir notamment :\n" +
        "• un abonnement mensuel\n" +
        "• un abonnement annuel\n\n" +
        "Les prix, les fonctionnalités incluses et les conditions sont affichés directement dans la partie Abonnement & Paiements.",
    },
    {
      q: "FullMetrix garantit-il les résultats du trader ?",
      a:
        "Non.\n\n" +
        "FullMetrix fournit des outils d'organisation, d'analyse, d'automatisation et d'aide à la décision.\n\n" +
        "La plateforme ne garantit pas :\n" +
        "• la rentabilité\n" +
        "• l'atteinte d'un objectif\n" +
        "• l'absence de pertes\n" +
        "• la réussite d'une stratégie\n" +
        "• le respect automatique des règles d'un broker ou d'une prop firm\n\n" +
        "Le trader reste responsable de ses décisions, de sa stratégie et de sa gestion du risque.",
    },
    {
      q: "Comment contacter le support ou proposer une idée ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Pour une proposition ou une suggestion, il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• le nom de la fonctionnalité concernée\n" +
        "• une présentation claire de l'idée\n" +
        "• le problème que cette idée permettrait de résoudre\n" +
        "• une capture ou un exemple, si nécessaire",
    },
  ],
  related: ["agent-ia-mt5", "abonnement-paiements", "faq-generale"],
};

export const en = {
  title: "Other topics",
  tagline: "VPS, platform vision, ideas and subscription",
  readMin: 5,
  intro:
    "FullMetrix was built to bring professional tools to traders. In its current version, most features are mainly aimed at MetaTrader 5 users. This page gathers the cross-cutting topics: VPS, platform vision, improvement suggestions and how the subscription works.",
  brief: [
    "Understand why a VPS is recommended and how to use one",
    "Know where the platform is heading",
    "Learn how to suggest an idea and why FullMetrix runs on a subscription",
  ],
  steps: [
    { title: "Choose a VPS provider", text: "A VPS is a remote server that stays on permanently, even with your computer off." },
    {
      title: "Install MetaTrader 5 on the VPS",
      text: "Connect to the server from your computer, install MT5 then log into your trading account.",
    },
    {
      title: "Install the FullMetrix Agents",
      text: "Install the required Agents, then configure algorithmic trading, WebRequest and tokens.",
    },
    {
      title: "Leave the terminal running on the server",
      text: "The VPS then keeps MetaTrader 5 and the Agents running independently of your personal computer.",
    },
  ],
  tips: [
    "A VPS is especially recommended to get the most out of the automatic features (Copy Trading, continuous sync, multiple accounts).",
    "FullMetrix guarantees neither profitability, nor reaching a target, nor the absence of losses: the trader stays responsible for their decisions.",
    "Improvement suggestions are welcome through support.",
  ],
  faq: [
    {
      q: "Who is FullMetrix mainly for?",
      a:
        "FullMetrix was built to bring professional tools to traders.\n\n" +
        "In its current version, most features are mainly aimed at MetaTrader 5 users.\n\n" +
        "This includes:\n" +
        "• the AI Agent\n" +
        "• the Automatic journal\n" +
        "• Order execution\n" +
        "• Copy Trading\n" +
        "• Challenges\n" +
        "• FMReplay and Backtest\n\n" +
        "Other platforms may progressively be supported as FullMetrix evolves.",
    },
    {
      q: "Why use a VPS with FullMetrix?",
      a:
        "A VPS is a remote server that stays on permanently.\n\n" +
        "It keeps MetaTrader 5 and the FullMetrix Agents running even when:\n" +
        "• your personal computer is off\n" +
        "• you are logged out\n" +
        "• you are travelling\n" +
        "• you do not want to leave your computer on all the time\n\n" +
        "A VPS is especially recommended to get the most out of the automatic FullMetrix features.",
    },
    {
      q: "How do I use FullMetrix with a VPS?",
      a:
        "You must:\n\n" +
        "1. choose an online VPS provider\n" +
        "2. connect to the server from your computer\n" +
        "3. install MetaTrader 5 on the VPS\n" +
        "4. log into your trading account\n" +
        "5. install the required FullMetrix Agents\n" +
        "6. configure algorithmic trading, WebRequest and tokens\n" +
        "7. leave MetaTrader 5 open on the server\n\n" +
        "Once configured, the VPS keeps MetaTrader 5 and the Agents running independently of your personal computer.",
    },
    {
      q: "Can I manage everything from FullMetrix once the VPS is set up?",
      a:
        "The goal of FullMetrix is to let the trader manage a large part of their activity directly from the platform.\n\n" +
        "When the Agent is properly connected on a VPS, you can:\n" +
        "• follow your account data\n" +
        "• consult your Automatic journal\n" +
        "• analyse your performance\n" +
        "• send orders\n" +
        "• manage some positions\n" +
        "• use Copy Trading\n" +
        "• follow your Challenges\n\n" +
        "You therefore no longer need to keep MetaTrader 5 open on your personal computer.\n\n" +
        "The terminal must still stay active on the VPS to keep the connection with FullMetrix.",
    },
    {
      q: "What is the FullMetrix vision?",
      a:
        "FullMetrix is not limited to a single tool.\n\n" +
        "Our goal is to progressively build a real management and assistance environment for traders.\n\n" +
        "The platform aims to centralise:\n" +
        "• trading tools\n" +
        "• performance analysis\n" +
        "• automation\n" +
        "• account management\n" +
        "• backtesting\n" +
        "• strategy structuring\n" +
        "• AI assistance\n\n" +
        "New features will be added progressively to extend the platform beyond MetaTrader 5.",
    },
    {
      q: "Can I suggest an idea or an improvement?",
      a:
        "Yes.\n\n" +
        "FullMetrix also evolves thanks to community feedback.\n\n" +
        "Users can contact support to suggest:\n" +
        "• a new feature\n" +
        "• an improvement to an existing tool\n" +
        "• a fix\n" +
        "• an automation idea\n" +
        "• a specific need met in their trading activity\n\n" +
        "Please present briefly:\n" +
        "• the problem encountered\n" +
        "• the proposed solution\n" +
        "• its usefulness for traders\n" +
        "• a concrete example, if possible\n\n" +
        "Every suggestion can help us improve the platform.",
    },
    {
      q: "Why does FullMetrix work on a subscription?",
      a:
        "The tools offered involve significant costs, including:\n" +
        "• development\n" +
        "• servers\n" +
        "• maintenance\n" +
        "• security\n" +
        "• artificial intelligence\n" +
        "• updates\n" +
        "• technical support\n\n" +
        "Running this kind of infrastructure can represent several thousand dollars.\n\n" +
        "FullMetrix still offers an affordable subscription so traders can use these tools long term without bearing those costs individually.",
    },
    {
      q: "What subscription types are available?",
      a:
        "FullMetrix offers subscription plans giving access to the platform features.\n\n" +
        "Depending on the offers available, you can choose:\n" +
        "• a monthly subscription\n" +
        "• an annual subscription\n\n" +
        "Prices, included features and conditions are displayed directly in the Subscription & Payments section.",
    },
    {
      q: "Does FullMetrix guarantee the trader's results?",
      a:
        "No.\n\n" +
        "FullMetrix provides organisation, analysis, automation and decision-support tools.\n\n" +
        "The platform does not guarantee:\n" +
        "• profitability\n" +
        "• reaching a target\n" +
        "• the absence of losses\n" +
        "• the success of a strategy\n" +
        "• automatic compliance with a broker's or prop firm's rules\n\n" +
        "The trader remains responsible for their decisions, strategy and risk management.",
    },
    {
      q: "How do I contact support or suggest an idea?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "For a suggestion, please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the name of the feature involved\n" +
        "• a clear presentation of the idea\n" +
        "• the problem the idea would solve\n" +
        "• a screenshot or an example, if needed",
    },
  ],
  related: ["agent-ia-mt5", "abonnement-paiements", "faq-generale"],
};
